


Vue.component(
    'jiasu-boost',
    resolve => require(["../../components/Jiasu/jiasuBoost"], resolve)
);

Vue.component(
    'jiasu-success',
    resolve => require(["../../components/Jiasu/success"], resolve)
);

Vue.component(
    'jiasu-header-operator-list',
    resolve => require(["../../components/Jiasu/headerOperatorList.vue"], resolve)
);


Vue.component(
    'jiasu-go-speed',
    resolve => require(["../../components/tips/goSpeedAlert"], resolve)
);


Vue.component(
    'jiasu2-go-speed',
    resolve => require(["../../components/tips/goJiasuSpeedAlert"], resolve)
);


// 下线宽带提速弹窗
Vue.component(
    'tape-out-alert',
    require('../../components/tips/tapeOutAlert')
);

Vue.component(
    "cmcc-middle",
    require("../../components/Jiasu/cmccMiddle")
)

//618活动
Vue.component(
    'get-618coupon-alert',
    resolve => require(["../../components/Jiasu/jiasu2CouponAlert"], resolve)
);

//宽带提速范围
Vue.component(
    'jiasu-range',
    resolve => require(["../../components/Jiasu/jiasuRange"], resolve)
);

//宽带提速范围地图悬浮表格
Vue.component(
    'jiasu-range-table',
    resolve => require(["../../components/Jiasu/jiasuRangeTable"], resolve)
);

//移动宽带提速悬浮导航
Vue.component(
    'cmcc-sus-dom',
    resolve => require(["../../components/Jiasu/cmccSus.vue"], resolve)
);


//主播加速首页
Vue.component(
    'streamer-accelerator',
    resolve => require(["../../components/streamerAccelerator/index.vue"], resolve)
);
//主播加速导航条
Vue.component(
    'streamer-header',
    resolve => require(["../../components/streamerAccelerator/header.vue"], resolve)
);
//主播加速价格
Vue.component(
    'streamer-price',
    resolve => require(["../../components/streamerAccelerator/price.vue"], resolve)
);

//主播加速banner
Vue.component(
    'streamer-banner',
    resolve => require(["../../components/streamerAccelerator/banner.vue"], resolve)
);

//主播加速优势
Vue.component(
    'streamer-advantage',
    resolve => require(["../../components/streamerAccelerator/advantage.vue"], resolve)
);
//主播加速场景
Vue.component(
    'streamer-scene',
    resolve => require(["../../components/streamerAccelerator/scene.vue"], resolve)
);

//主播加速导航条
Vue.component(
    'streamer-goto-list',
    resolve => require(["../../components/streamerAccelerator/gotoList.vue"], resolve)
);

//主播加速支付成功
Vue.component(
    'streamer-buy-success',
    resolve => require(["../../components/streamerAccelerator/buySuccess.vue"], resolve)
);

// 提速页面重写组件
Vue.component(
    'jiasu-new-speedup',
    resolve => require(["../../components/Jiasu/newSpeedup"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/speedUp.js